import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../_services/language.service';
import { environment } from '../../environments/environment';
import { IndexedDbService } from '../_services/indexed-db.service';
import { SharedService } from '../_services/shared.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public showTips = false;
  public isDarkMode = false;

  constructor(
    public router: Router,
    public LanguageService: LanguageService,
    private db: IndexedDbService,
    private sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    const darkMode = localStorage.getItem('dark_mode');
    this.isDarkMode = darkMode === 'true';
    if (this.isDarkMode) {
      document.body.classList.add('dark');
    }
  }

  public abrirTooltip(): void {
    window.open('/tooltip', '_blank', 'width=530,height=470,noopener,noreferrer');
  }

  public logout(): void {
    const logoutUrl = `https://uatwebmtz.b2clogin.com/uatwebmtz.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/logout?post_logout_redirect_uri=${environment.redirectUrl}/login`;
    this.db.clear();
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = logoutUrl;
  }

  onMenuToggle(): void {
    this.sharedService.toggleSidebar();
  }

  toggleDarkMode() {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('dark_mode', this.isDarkMode.toString());
    if (this.isDarkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
}
